<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import Zframe from '../_common/z/zframe.svelte'
    import LoadSpinner from './load-spinner.svelte'
    import Zinput from './z/zinput.svelte'
    import { faPaperPlane } from '@fortawesome/free-solid-svg-icons'
    import { SendMessageTemplate } from './send-message.template'
    // ##############################################################################################################
    const dispatch = createEventDispatcher()

    export let token: string
    export let personId: string = null

    function compactToken(t: string) {
        t = t.replace(':', '_')
        let left = t.split('_')[0]
        let right = t.split('_')[1]
        return window.api.utils.conversions.uuidToBase58(left) + '_' + window.api.utils.conversions.uuidToBase58(right)
    }

    let expiration: number = 7
    let linkUrl: string = ''
    linkUrl = window.api.utils.utils.domain() + '/public/share?id=' + compactToken(token)

    let linkField
    function copyLink() {
        window.api.utils.utils.copyToClipboard(linkField.value)
        window.alert('Link copiado')
    }

    let show = false
    async function updateLinkExpiration() {
        show = true
        let expiresAt = new Date()
        expiresAt.setDate(expiresAt.getDate() + expiration)
        expiresAt = window.api.utils.dates.setDateToLastSecondFromDate(expiresAt)
        console.log('exp', expiresAt)
        await window.api.tools.sharePages.update(token.split('_')[0], { expiresAt })
        show = false
    }

    let options: { label: string; value: number }[] = [
        { label: '1 dia', value: 1 },
        { label: '3 dias', value: 3 },
        { label: '7 dias', value: 7 },
        { label: '10 dias', value: 10 },
        { label: '15 dias', value: 15 },
        { label: '30 dias', value: 30 },
        { label: '90 dias', value: 90 },
    ]

    function sendMessage() {
        window.message(SendMessageTemplate.share_link_02('public/share?id=' + token, 'Compartilhamento de dados', personId))
    }
</script>

<LoadSpinner {show} delay={0}></LoadSpinner>
<div class="root">
    <Zframe class="m-3" title="Link de compartilhamento" acts={[{ label: 'Enviar', icon: faPaperPlane, callback: sendMessage }]}>
        <Zinput type="select" label="Validade do link" {options} bind:value={expiration} on:change={updateLinkExpiration}></Zinput>
        <Zinput class="mt-2" disabled={true} label="Link" value={linkUrl} showCopy={true}></Zinput>
    </Zframe>
    <Zframe class="m-3 mt-0">
        Importante:<br />
        Qualquer pessoa com acesso ao link terá acesso ao conteúdo.<br />
        O link ficará indisponível após sua data de validade.<br />
        O conteúdo do link é estático e não reflete as alterações feitas após sua emissão.
    </Zframe>
</div>
